/**
 * Generated bundle index. Do not edit.
 */

export * from './adapter-ajax-jquery';
